import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CustomRouter } from 'src/admin-front/ajs-upgraded-providers';
import { BasicService } from 'src/app/shared/services/basic.service';
import { GmbService } from 'src/app/shared/strategies/channels';
import { AuthorizedGoogleAccount } from '../../shared/models/authorized-google-account.model';
import { GoogleBusinessProfileService } from '../google-business-profile.service';
@Component({
  selector: 'app-google-business-profile-login',
  templateUrl: './google-business-profile-login.component.html',
  styleUrls: ['./google-business-profile-login.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class GoogleBusinessProfileLoginComponent {
  @Input() googleAccountAttachedToAlcmeon: AuthorizedGoogleAccount;

  backToLabel = this.basicService.translate('add-account/google-business-profile/login/back-to-accounts');

  constructor(
    private basicService: BasicService,
    private customRouter: CustomRouter,
    private gmbService: GmbService,
    private googleBusinessProfileService: GoogleBusinessProfileService
  ) {}

  goBack() {
    this.customRouter.go('auth.alcmeon.fuse.parameters.accounts', { channel: this.gmbService.getType() });
  }

  useGoogleAccount() {
    this.googleBusinessProfileService.useGoogleAccount(this.googleAccountAttachedToAlcmeon.auth_id);
  }

  connectGoogleAccount() {
    this.googleBusinessProfileService.connectGoogleAccount();
  }
}
